import { addHours } from 'date-fns'

const HOURS_PER_WEEK = 7 * 24

/**
 * Compute the max bookable date using booking window **hours** as canonical.
 */
export const getBookingWindowMaxDate = (
  now: Date,
  bookingWindowInHours?: number,
): Date | undefined => {
  if (bookingWindowInHours == null) {
    return undefined
  }

  return addHours(now, bookingWindowInHours)
}

/**
 * Returns a display-friendly booking window in **weeks**, derived solely from hours.
 */
export const getDisplayBookingWindowInWeeks = (
  bookingWindowInHours?: number,
): number | undefined => {
  if (bookingWindowInHours == null) {
    return undefined
  }

  const weeks = bookingWindowInHours / HOURS_PER_WEEK
  const rounded = Math.round(weeks)

  if (rounded > 0) {
    return rounded
  }

  if (bookingWindowInHours > 0) {
    // For tiny positive windows (< 1 week), still show "1 week".
    return 1
  }

  return 0
}
